import { render, staticRenderFns } from "./PhoneticText.vue?vue&type=template&id=ac9e7c56&scoped=true"
import script from "./PhoneticText.vue?vue&type=script&lang=js"
export * from "./PhoneticText.vue?vue&type=script&lang=js"
import style0 from "./PhoneticText.vue?vue&type=style&index=0&id=ac9e7c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9e7c56",
  null
  
)

export default component.exports